module.exports = __webpack_public_path__ + "static/media/tablet-alt.e1495523.svg";